export default "__VITE_ASSET__BvA7tLSI__"